<template>
    <footer class="py-16">
      <div class="container px-4 mx-auto">
        <div class="flex flex-col lg:flex-row items-center lg:justify-between">
          <p class="text-sm  text-left text-blueGray-400"><span class="font-medium">Need help?</span><br>
            Reach out to <a href="support@mayagent.xyz">support@mayagent.xyz</a> or click on the support link
            at the bottom right of this screen</p>
          <div class="order-first lg:order-last -mx-2 mb-4 lg:mb-0">
            <a class="inline-block px-2" href="https://x.com/MayaAI_Token" target="_blank">
              <img src="../assets/img/socials/twitter.svg" alt="EthereumX Twitter">
            </a>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>
